function initRichTextSliders() {
  if (typeof Swiper === 'undefined') return;

  document.querySelectorAll('[data-rt-image-slider]').forEach(function (el) {
    if (el.dataset.rtInitialized === 'true') return;
    el.dataset.rtInitialized = 'true';

    var slidesMobile = parseFloat(el.dataset.slidesMobile) || 1.2;
    var slidesDesktop = parseFloat(el.dataset.slidesDesktop) || 2.5;
    var slideGap = parseInt(el.dataset.slideGap, 10) || 0;
    // 모바일 전용 간격. 지정하지 않으면 PC 값을 그대로 쓴다(기존 동작 유지).
    var slideGapMobile = parseInt(el.dataset.slideGapMobile, 10) || slideGap;
    var autoplayEnabled = el.dataset.autoplay === 'true';
    var loopEnabled = el.dataset.loop === 'true';
    var autoplayDelay = parseInt(el.dataset.autoplayDelay, 10) || 3000;
    var autoplaySpeed = parseInt(el.dataset.autoplaySpeed, 10) || 600;
    var pauseOnHover = el.dataset.pauseOnHover === 'true';
    var autoplayReverse = el.dataset.autoplayDirection === 'right';
    var slideCount = el.querySelectorAll('.swiper-slide').length;
    var minSlidesForLoop = Math.ceil(Math.max(slidesMobile, slidesDesktop)) + 1;
    var scrollbarEl = el.querySelector('.swiper-scrollbar');

    if (slideCount < 2) return;

    var enableLoop = loopEnabled && slideCount >= minSlidesForLoop;
    var swiperOptions = {
      slidesPerView: slidesMobile,
      spaceBetween: slideGapMobile,
      speed: autoplaySpeed,
      threshold: 10,
      loop: enableLoop,
      rewind: !enableLoop && autoplayEnabled,
      freeMode: {
        enabled: !autoplayEnabled,
        sticky: false,
        momentumBounce: true,
      },
      breakpoints: {
        750: {
          slidesPerView: slidesDesktop,
          spaceBetween: slideGap,
        },
      },
    };

    if (scrollbarEl) {
      swiperOptions.scrollbar = {
        el: scrollbarEl,
        draggable: true,
        hide: false,
      };
    }

    if (autoplayEnabled) {
      swiperOptions.autoplay = {
        delay: autoplayDelay,
        disableOnInteraction: false,
        pauseOnMouseEnter: pauseOnHover,
        reverseDirection: autoplayReverse,
      };
    }

    new Swiper(el, swiperOptions);
  });
}

function destroyRichTextSliders(root) {
  var scope = root || document;

  scope.querySelectorAll('[data-rt-image-slider]').forEach(function (el) {
    if (el.swiper) {
      el.swiper.destroy(true, true);
    }

    delete el.dataset.rtInitialized;
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRichTextSliders);
} else {
  initRichTextSliders();
}

document.addEventListener('shopify:section:load', initRichTextSliders);
document.addEventListener('shopify:section:unload', function (event) {
  destroyRichTextSliders(event.target);
});
